/**
 * Página: Construção Civil
 */
import SegmentPage from '../../components/SegmentPage'

const segment = {
  name: 'Construção Civil',
  tagline: 'Obra segura, produtiva e controlada.',
  description: 'Controle de ponto, EPIs e produtividade para canteiros de obra. Compliance com NR-18 e todas as normas do setor.',
  icon: '🏗️',
  color: '#F97316',
  gradient: 'linear-gradient(135deg, #F97316 0%, #F59E0B 100%)',
  painPoints: [
    'Fraude no ponto com biometria molhada ou suja',
    'Dificuldade de controlar uso de EPIs em obra',
    'Colaboradores em múltiplas frentes de trabalho',
    'Acidentes por falta de equipamentos',
    'Produtividade invisível no canteiro',
    'Compliance com dezenas de NRs',
  ],
  benefits: [
    'Ponto facial funciona com capacete e poeira',
    'Detecção automática de EPIs por câmera',
    'Geolocalização por frente de obra',
    'Alertas em tempo real de desvios',
    'Produtividade medida por visão computacional',
    'Relatórios de compliance automáticos',
  ],
  nrs: ['NR-6', 'NR-18', 'NR-35', 'NR-12', 'NR-33', 'NR-10'],
  stats: [
    { value: '-67%', label: 'Acidentes' },
    { value: '+23%', label: 'Produtividade' },
    { value: '98%', label: 'Compliance' },
    { value: '0', label: 'Fraudes' },
  ],
  testimonial: {
    quote: 'O WorkStream eliminou fraudes de ponto e reduziu nossos acidentes em 70%. O ROI foi em 3 meses.',
    author: 'Carlos Mendes',
    role: 'Diretor de Obras',
    company: 'ConstruBem S.A.',
  },
}

export default function ConstrucaoCivil() {
  return <SegmentPage segment={segment} />
}

